import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestInvoiceList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/invoice`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/invoice?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestGetByIdInvoice(data) {
  return fetch.get(`${BASE_URL}/api/app/invoice/getById/${data.id}`);
}

export function createInvoice(params) {
  return fetch.post(
    `${BASE_URL}/api/app/invoice/createInvoiceWithItems`,
    params
  );
}

export function editInvoice(params) {
  return fetch.put(`${BASE_URL}/api/app/invoice/update/invoice`, params);
}

export function createInvoiceFromBills(params) {
  return fetch.post(`${BASE_URL}/api/app/invoice/rental-bills/invoice`, params);
}

export function editInvoiceStatus(params) {
  const { entryInTally, id } = params;
  return fetch.put(`${BASE_URL}/api/app/invoice/${id}`, params);
}

export function invoiceStatusToGenerated(params) {
  return fetch.post(`${BASE_URL}/api/app/invoice/generateInvoice`, params);
}

export function invoiceResendEmail(params) {
  return fetch.post(`${BASE_URL}/api/app/invoice/resendEmail`, params);
}

export function paymentReminderEmail(params) {
  return fetch.post(`${BASE_URL}/api/app/payments/paymentReminder`, params);
}

export function cancelInvoice(params) {
  return fetch.post(`${BASE_URL}/api/app/external-api/cancelEinvoice`, params);
}

export function generateEWayBill(params) {
  return fetch.post(
    `${BASE_URL}/api/app/external-api/generateEwayBill`,
    params
  );
}

export function invoiceGenerateDCPdf(params) {
  return fetch.post(`${BASE_URL}/api/app/invoice/generatePdf`, params);
}

export function requestLastInvoiceAndCreditNoteList(params) {
  return fetch.get(`${BASE_URL}/api/app/invoice/lastInvoiceAndCreditNote`, {
    params: { limit: Number.MAX_SAFE_INTEGER },
  });
}

export function invoiceGeneratePdf(data) {
  return fetch.post(`${BASE_URL}/api/app/invoice/generatePdf/${data.id}`);
}
export function requestmissinvoice(params) {
  return fetch.get(`${BASE_URL}/api/app/invoice/missedInvoice`, {
    params: params,
  });
}

export function createFinancialInvoice(params) {
  return fetch.post(
    `${BASE_URL}/api/app/invoice/generateFinancialInvoice`,
    params
  );
}

export function requestInvoiceNoList(params) {
  return fetch.get(`${BASE_URL}/api/app/invoice/getInvoiceNo`, {
    params: { limit: Number.MAX_SAFE_INTEGER },
  });
}
export function requestPendingEInvoiceList(data) {
  return fetch.post(
    `${BASE_URL}/api/app/invoice/generatependingInvoiceList`,
    data
  );
}

export function requestOptimizedInvoiceList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/invoice/invoiceList`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/invoice/invoiceList?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestInvoiceAndCreditNoteList(params) {
  // return fetch.get(
  //   `${BASE_URL}/api/app/invoice/get-invoice-creditnote?${params}`
  // );
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/invoice/get-invoice-creditnote?`, {
      params: { limit: 10, pgno: 1, clientId: '63a072426baceb82403570970', uniqueNo: [] },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/invoice/get-invoice-creditnote?${params}`);
  }
}
export function awsPdfFileDecode(params) {
  return fetch.post(`${BASE_URL}/api/app/client/getAwsPdfFile`, params);
}
